import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67361c8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header flex-bwn" }
const _hoisted_2 = { class: "title flex-ter" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "vip_logo",
  src: "https://static-s.theckb.com/BusinessMarket/member/vip_logo.png",
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips mt_5" }, "ビジネス会員様以上のお客様向けに、1対1の商品提案を提供しています。お好みの商品画像を「お気に入り」に追加いただくと、CKBが該当商品の購入リンクを作成します", -1))
const _hoisted_5 = { class: "mt_5" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "card"
}
const _hoisted_8 = {
  key: 1,
  class: "card flex-bwn"
}
const _hoisted_9 = {
  key: 2,
  class: "card flex"
}

import { t } from '@/plugins/i18n'
import ChoiceCard from './ChoiceCard.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import Drawer from './Drawer.vue'
import { request } from '@/config/request/interceptors'
import { QueryShareLinkListRespVO } from '@/service/goods'
import { isJA, useLevel, useRtfix, useUser } from '@/store'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()
const show = ref(false)
const drawerRef = ref()

const user = useUser()

const level = useLevel()

const membership = computed(() => store.getters.membership)
const jump = () => {
  drawerRef.value.open()
}
const shareLinksList = ref<QueryShareLinkListRespVO[]>([])
onMounted(async () => {
  const res = await request.goods.productAtlas.queryCustomerShareLinks({
    pageNo: 1,
    pageSize: 100
  })
  shareLinksList.value = res.data?.records ?? []
  show.value = !!res?.data?.records?.length
})


return (_ctx: any,_cache: any) => {
  const _component_ElButton = _resolveComponent("ElButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (shareLinksList.value.length || _unref(level) <= 2)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["choice-part", shareLinksList.value.length ? 'hasChoice' : ''])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_unref(t)('一对一专属选品提案')), 1)
            ]),
            (shareLinksList.value.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "more",
                  onClick: jump
                }, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('查看更多')) + " >", 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (!shareLinksList.value.length && _unref(level) <= 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_ElButton, {
                    type: "primary",
                    round: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(_unref(useRtfix)('VipLevel'))))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('升级会员')), 1)
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : _createCommentVNode("", true),
          (shareLinksList.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (shareLinksList.value.length === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(ChoiceCard, {
                        max: 9,
                        choice: shareLinksList.value[0],
                        "show-new": true
                      }, null, 8, ["choice"])
                    ]))
                  : _createCommentVNode("", true),
                (shareLinksList.value.length === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(ChoiceCard, {
                        style: {"margin-right":"8px"},
                        max: 4,
                        choice: shareLinksList.value[0],
                        "show-new": true
                      }, null, 8, ["choice"]),
                      _createVNode(ChoiceCard, {
                        max: 4,
                        choice: shareLinksList.value[1]
                      }, null, 8, ["choice"])
                    ]))
                  : _createCommentVNode("", true),
                (shareLinksList.value.length > 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(ChoiceCard, {
                        style: {"margin-right":"8px"},
                        max: 3,
                        choice: shareLinksList.value[0],
                        "show-new": true
                      }, null, 8, ["choice"]),
                      _createVNode(ChoiceCard, {
                        style: {"margin-right":"8px"},
                        max: 3,
                        choice: shareLinksList.value[1]
                      }, null, 8, ["choice"]),
                      _createVNode(ChoiceCard, {
                        max: 3,
                        choice: shareLinksList.value[2]
                      }, null, 8, ["choice"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2)), [
          [_vShow, _unref(isJA)()]
        ])
      : _createCommentVNode("", true),
    _createVNode(Drawer, {
      list: shareLinksList.value,
      ref: (_value, _refs) => {
        _refs['drawerRef'] = _value
        drawerRef.value = _value
      }
    }, null, 8, ["list"])
  ], 64))
}
}

})